import { useEffect, useState } from 'react'
import { getGeneric } from '../../common/constants'

// About PACE → Signals. Every signal the served PACE model reads and, for a merchant, which
// of them its settings use for ranking. Admin relay: any merchant (proship PaceSignalsController).
export const fetchPaceSignals = (merchantId, paymentMode) =>
  getGeneric('allocation/pace-signals', {
    ...(merchantId ? { merchantId } : {}),
    ...(paymentMode ? { paymentMode } : {}),
  }).then((r) => r.data)

// Signal count for the headline numbers on the other tabs; one fetch per page load.
let countPromise = null
export function useSignalCount(fallback = 165) {
  const [n, setN] = useState(fallback)
  useEffect(() => {
    let live = true
    countPromise = countPromise || fetchPaceSignals().then((d) => d.n_signals).catch(() => null)
    countPromise.then((v) => { if (live && v) setN(v) })
    return () => { live = false }
  }, [])
  return n
}
